import {
  AfterContentInit,
  AfterViewChecked,
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { createForm } from "../../../bpmn.io/@bpmn-io/form-js-viewer";
import RenderExtensionInput from "../../extension/input";
import selectUsuarios from "../../extension/custom-select-usuarios";
import { Observable, Subscription, firstValueFrom, lastValueFrom, filter, distinctUntilChanged, take } from "rxjs";
import { BaseServiceService } from "../../services/base-service.service";
import { HttpClient } from "@angular/common/http";
import { AppData } from "../../helpers/app-data";
import { Form } from "../../../bpmn.io/@bpmn-io/form-js-viewer";
import { Router } from "@angular/router";
import { ModalNotifyTypes } from "../modal-notify/modal-notify.component";
import FeedbackButtonRenderExtension from "../../extension/custom-button-files";
import visualizadorArchivos from "../../extension/visualizadorArchivos";
import DataSelector from "../../extension/data-selector";
import ExpandableTable from "../../extension/expandable-table";
import CascadeSelect from "../../extension/cascade-select";
import { CODIGOS_ENLACE_CERRADO, SesionEnlaceService } from "../../services/sesion-enlace.service";

declare var fabric: any;

@Component({
  selector: "app-render-form",
  templateUrl: "./render-form.component.html",
  styleUrl: "./render-form.component.css",
})
export class RenderFormComponent
  implements OnInit, OnDestroy, AfterViewChecked
{
  botonProcesando = true;
  private currentFormIdSubscription?: Subscription;
  private currentIdEjecucionProcesoSubscription?: Subscription;
  private currentIdEjecucionTareaSubscription?: Subscription;
  
  constructor(
    private baseService: BaseServiceService,
    private http: HttpClient,
    private router: Router,
    public sesionEnlace: SesionEnlaceService
  ) {}

  formID: number | null = null;
  formLoaded: any;
  idEjecucionProceso: string | any;
  idEjecucionTarea: string | any;
  globalData: any;
  aditionalFlowData: any;
  isLoading: boolean = true;
  private formAlreadyLoaded: boolean = false;
  isRedirectAccess: boolean = false;
  private redirectAccessSubscription?: Subscription;

  /** Estado del modal de progreso de carga por chunks */
  chunkProgress = {
    activo: false,
    archivoActual: 0,
    totalArchivos: 0,
    parteActual: 0,
    totalPartes: 0,
    nombreArchivo: ''
  };
  /** Evita llamadas al DOM tras ngOnDestroy cuando el envío corre en segundo plano */
  private isDestroyed = false;
  /** Impide un segundo envío del mismo formulario mientras el primero sigue en curso (hallazgo 27) */
  private envioEnCurso = false;
  /** Acceso por enlace: tras guardar se muestra la pantalla de cierre en lugar del formulario */
  envioCompletado = false;

  private form = new Form();
  async ngOnInit() {
    // Acceder a los datos globales desde window
    this.globalData = (window as any).globalData;
    this.aditionalFlowData = (window as any).aditionalFlowData;

    // Definir un callback para manejar actualizaciones de datos
    (window as any).onGlobalDataUpdate = (data: any) => {
      this.globalData = data;
    };

    (window as any).onAditionalFlowDataUpdate = (data: any) => {
      this.aditionalFlowData = data;
    };

    var ButtonElements = document.querySelectorAll(".ms-Button");
    for (var i = 0; i < ButtonElements.length; i++) {
      new fabric["Button"]();
    }
    var SpinnerElements = document.querySelectorAll(".ms-Spinner");
    for (var i = 0; i < SpinnerElements.length; i++) {
      new fabric["Spinner"](SpinnerElements[i]);
    }
    this.currentFormIdSubscription = this.baseService.currentFormId
      .pipe(
        filter((formId: any) => formId !== null && formId !== undefined),
        take(1) // SOLUCIÓN: Solo tomar la primera emisión válida
      )
      .subscribe(
        (formId: any) => {
          this.loadForm(formId);
        }
      );
    this.currentIdEjecucionProcesoSubscription =
      this.baseService.currentIdEjecucionProceso.subscribe((idEjecucion) => {
        /* this.handleFormIdChange(formId) */

        this.idEjecucionProceso = idEjecucion;
      });
    this.currentIdEjecucionTareaSubscription =
      this.baseService.currentIdEjecucionTarea.subscribe((idEjecucion) => {
        /* this.handleFormIdChange(formId) */

        this.idEjecucionTarea = idEjecucion;
      });
    
    this.redirectAccessSubscription = this.baseService.isRedirectAccess$.subscribe(
      isRedirect => this.isRedirectAccess = isRedirect
    );
  }

  async loadForm(formId: string) {
    try {
      this.formAlreadyLoaded = true;
      this.formID = Number(formId);

      const response = await firstValueFrom(this.getFormConfig());
      this.formLoaded = JSON.parse(response.Data.Configuracion);

      let schema = this.formLoaded;
      let variables;
      const container = document.querySelector("#form");

      const components = schema.components;
      const responseVariables = await this.baseService
        .getAll(
          `EjecucionProceso/ObtenerDatosVariablesEjecucion?IdEjecucion=${this.idEjecucionProceso}`
        )
        .toPromise();

      if (responseVariables.Ok) {
        console.log(responseVariables);
        variables = responseVariables.Data;
        // Guardar como mapa { id: valor } accesible para extensiones (ej: viewerButton)
        const varMap: Record<string, any> = {};
        for (const v of variables) {
          varMap[v.Id] = v.Valor;
        }
        (window as any).processVariables = varMap;
      }

      for (const element of components) {
        let field = element;

        if (field.defaultValue) {
          if (
            typeof field.defaultValue === "string" &&
            field.defaultValue.startsWith("@")
          ) {
            let valueDefault = field.defaultValue.replace("@", "");
            for (const variable of variables) {
              if (variable.Id === valueDefault) {
                field.defaultValue = variable.Valor;
                break; // Detiene la búsqueda una vez que se encuentra el valor
              }
            }
          }
        }
      }

      this.form = await createForm({
        schema,
        container,
        additionalModules: [
          RenderExtensionInput,
          selectUsuarios,
          FeedbackButtonRenderExtension,
          visualizadorArchivos,
          DataSelector,
          ExpandableTable,
          CascadeSelect,
        ],
      });

      this.botonProcesando = false;

      // Agregar manejador de eventos para el botón "Descargar plantilla"
      container!.addEventListener('downloadTemplate', this.handleDownloadTemplateBase64.bind(this));

      /*      form.on("changed", () => {
        console.log("Formulario importado y configurado correctamente.");

      }); */

      /*      const eventBus:any = form.get('eventBus');
      console.log(eventBus);
      
      eventBus.on('form.init', ()=>{
        console.log('improt');
        
      }) */

      this.form.on("submit", async (event) => {
        this.isLoading = false;

        const { data, errors } = event;

        // Validar campos requeridos antes de proceder
        if (errors && Object.keys(errors).length > 0) {
          this.isLoading = true;
          this.baseService.triggerShowModal(
            "Campos requeridos",
            "Faltan campos requeridos por completar",
            ModalNotifyTypes.Warning,
            false
          );
          return;
        }

        // Nota: sanitizeFormData se llama justo antes de cada JSON.stringify(data),
        // DESPUÉS de todas las mutaciones (data.flujo, data.Documentos).
        // No se llama aquí para evitar que Object.assign rehaga objetos ya serializados.

        // const formField = this.form.get("formFieldRegistry");

        const rows = document.querySelectorAll(".docRow");

        if (rows.length > 0) {
          let ObsRequired = false;

          for (var i = 0; i < this.globalData.length; ++i) {
            if (!this.globalData[i]["Aprobado"]) {
              if (!this.globalData[i]["Observaciones"]) {
                ObsRequired = true;
                break;
              }
            }
          }

          if (!ObsRequired) {
            $("#requiredObsError").hide();

            // Deep-clone vía JSON para resolver todos los Proxies internos de form-js
            // antes de procesar (Object.assign solo copia referencias superficiales)
            // const plainData: any = JSON.parse(JSON.stringify(data));
            // plainData["Documentos"] = this.globalData;
            // let Datos = this.sanitizeFormData(plainData);
            // console.log('[render-form] DatosTarea (docs branch):', Datos);
            data["Documentos"] = this.globalData;
            this.injectExpandableTableCounts(data);
            this.iniciarEnvioBackground(data, true);
          } else {
            $("#requiredObsError").html(
              "Las observaciones de los documentos no aprobados son requeridas"
            );
            $("#requiredObsError").show();
            this.isLoading = true;
          }
        } else {

          // Deep-clone vía JSON para resolver todos los Proxies internos de form-js
          // antes de procesar (Object.assign solo copia referencias superficiales)
          // const plainData: any = JSON.parse(JSON.stringify(data));
          // if(this.aditionalFlowData)
          // {
          //   plainData.flujo = Object.assign({}, plainData.flujo, this.aditionalFlowData);
          // }

          // let Datos = this.sanitizeFormData(plainData);
          if(this.aditionalFlowData)
          {
            data.flujo = Object.assign({}, data.flujo, this.aditionalFlowData);            
          }

          this.injectExpandableTableCounts(data);
          this.iniciarEnvioBackground(data, false);
        }
      });

      this.isLoading = true;
      /* 
      form.on('changed', 500, (event) => {
        console.log('Form <changed>', event);
      });
       */
    } catch (error) {
      console.error("Error loading form configuration:", error);
      this.baseService.triggerShowModal(
        "Ha ocurrido un error cargando el formulario",
        "Hay un error en la estructura del formulario",
        ModalNotifyTypes.Danger,
        false
      );
      this.botonProcesando = false;
    }
  }

  ngOnDestroy(): void {
    this.isDestroyed = true;
    this.formAlreadyLoaded = false;
    if (this.currentFormIdSubscription) {
      this.currentFormIdSubscription.unsubscribe();
    }
    if (this.currentIdEjecucionProcesoSubscription) {
      this.currentIdEjecucionProcesoSubscription.unsubscribe();
    }
    if (this.redirectAccessSubscription) {
      this.redirectAccessSubscription.unsubscribe();
    }
    
    // Limpiar event listener
    const container = document.querySelector("#form");
    if (container) {
      container.removeEventListener('downloadTemplate', this.handleDownloadTemplateBase64.bind(this));
    }
    
    this.form.destroy();
  }

  ngAfterViewChecked(): void {
    const poweredByElement = document.querySelector(".fjs-powered-by");

    if (poweredByElement) {
      // Elimina el elemento del DOM

      poweredByElement.parentNode!.removeChild(poweredByElement);
    }
  }
  getFormConfig(): Observable<any> {
    return this.http.get<any>(
      `${AppData.API_URL}Formulario/GetFormularioConfiguracion?Id=${this.formID}`
    );
  }

  abrirDatatableTareas() {
    this.router.navigate(["home/tareas"]);
  }

  dialogComponent: any;

  abrirModalDatosAlmacenados() {
    var example : any = document.querySelector(".success");

    var dialog = example.querySelector(".modal-succes");

    this.dialogComponent = new fabric["Dialog"](dialog);

    this.dialogComponent.open();
  }

  cerrarModal() {
    if (this.dialogComponent) {
      this.dialogComponent.close();
    }
    
    // Solo redirigir a tareas si NO es acceso desde redirect
    if (!this.isRedirectAccess) {
      this.abrirDatatableTareas();
    } else {
      this.envioCompletado = true;
    }
  }

  /** Cierra el modal de progreso; la carga continúa en segundo plano. */
  cerrarModalChunk(): void {
    this.chunkProgress.activo = false;
    if (!this.isRedirectAccess) {
      this.abrirDatatableTareas();
    }
  }

  // Manejar la descarga de la plantilla por url
  async handleDownloadTemplate(event: CustomEvent) {
    try {
      this.isLoading = false;
      
      const { field, data } = event.detail;
      
      // Obtener los datos actuales del formulario correctamente
      const formData = this.form._getState(); // Obtener el estado completo del formulario
      const currentData = formData.data || {}; // Obtener solo los datos del formulario
      
      console.log('Abriendo plantilla...', { field, data, formData, currentData });
      
      // Llamada al backend para obtener la plantilla
      const response = await lastValueFrom(
        this.http.get<any>(
          AppData.API_URL + `Formulario/DescargarPlantilla?IdPlantilla=${currentData.flujo.plantillaArquitectura}`,
          {
            headers: {
              "accept": "*/*"
            }
          }
        )
      );
      
      // Abrir la plantilla en una nueva página usando la URL de la respuesta
      const templateUrl = response.Data?.Data.Url;
      console.log('URL de la plantilla:', templateUrl);
      
      if (templateUrl) {
        // Abrir la URL en una nueva pestaña/ventana
        window.open(templateUrl, '_blank');
        
        this.baseService.triggerShowModal(
          "Plantilla abierta",
          "La plantilla se ha abierto en una nueva pestaña",
          ModalNotifyTypes.Success,
          false
        );
      } else {
        // Si no hay URL, mostrar error
        this.baseService.triggerShowModal(
          "Error al abrir plantilla",
          "No se pudo obtener la URL de la plantilla",
          ModalNotifyTypes.Danger,
          false
        );
      }
      
    } catch (error: any) {
      console.error('Error al abrir la plantilla:', error);
      
      this.baseService.triggerShowModal(
        "Error al abrir la plantilla",
        error.error?.Error || "Ha ocurrido un error al abrir la plantilla",
        ModalNotifyTypes.Danger,
        false
      );
    } finally {
      this.isLoading = true;
    }
  }

  // Manejar la descarga de la plantilla en Base64
  async handleDownloadTemplateBase64(event: CustomEvent) {
    try {
      this.isLoading = false;
      
      const { field, data } = event.detail;
      
      // Obtener los datos actuales del formulario correctamente
      const formData = this.form._getState(); // Obtener el estado completo del formulario
      const currentData = formData.data || {}; // Obtener solo los datos del formulario
      
      console.log('Descargando plantilla...', { field, data, formData, currentData });
      
      // Llamada al backend para obtener la plantilla en Base64
      const response = await lastValueFrom(
        this.http.get<any>(
          AppData.API_URL + `Formulario/DescargarPlantilla?IdPlantilla=${currentData.flujo.plantillaArquitectura}`,
          {
            headers: {
              "accept": "*/*"
            }
          }
        )
      );
      
      // Obtener los datos de la respuesta
      const templateData = response.Data?.Data;
      console.log('Datos de la plantilla:', templateData);
      
      if (templateData && templateData.Data && templateData.ResultType === 'Base64') {
        // Convertir Base64 a Blob
        const base64Data = templateData.Data;
        const fileName = templateData.NombreOriginal || `plantilla.${templateData.Extension || 'drawio'}`;
        
        // Detectar el tipo MIME basado en la extensión
        let mimeType = 'application/octet-stream';
        if (templateData.Extension) {
          switch (templateData.Extension.toLowerCase()) {
            case 'drawio':
              mimeType = 'application/drawio';
              break;
            case 'pdf':
              mimeType = 'application/pdf';
              break;
            case 'doc':
            case 'docx':
              mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
              break;
            case 'xls':
            case 'xlsx':
              mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
              break;
            default:
              mimeType = 'application/octet-stream';
          }
        }
        
        // Convertir Base64 a bytes
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        
        // Crear Blob y URL de descarga
        const blob = new Blob([byteArray], { type: mimeType });
        const url = window.URL.createObjectURL(blob);
        
        // Crear elemento de descarga y ejecutar
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        
        // Limpiar
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        
        this.baseService.triggerShowModal(
          "Plantilla descargada",
          `La plantilla "${fileName}" se ha descargado correctamente`,
          ModalNotifyTypes.Success,
          false
        );
      } else {
        // Si no hay datos Base64, mostrar error
        this.baseService.triggerShowModal(
          "Error al descargar plantilla",
          "No se pudieron obtener los datos de la plantilla en formato Base64",
          ModalNotifyTypes.Danger,
          false
        );
      }
      
    } catch (error: any) {
      console.error('Error al descargar la plantilla:', error);
      
      this.baseService.triggerShowModal(
        "Error al descargar la plantilla",
        error.error?.Error || "Ha ocurrido un error al descargar la plantilla",
        ModalNotifyTypes.Danger,
        false
      );
    } finally {
      this.isLoading = true;
    }
  }

  /**
   * Sanitiza el objeto de datos del formulario antes de enviarlo al backend.
   *
   * PROBLEMA RAÍZ: el backend tiene un converter JSON personalizado que, para cada
   * valor de tipo string en el Dictionary, intenta re-parsear el string como JSON.
   * Si el resultado es un objeto JSON ({...}) lo trata como Dictionary anidado.
   * Si el resultado es un array JSON ([...]) falla con "could not be converted to
   * Dictionary – BytePositionInLine: 1" porque los arrays no son Dictionary.
   *
   * SOLUCIÓN: antes de serializar cualquier objeto/array a string, convertir
   * RECURSIVAMENTE todos los arrays internos a objetos indexados {"0":{...},"1":{...}}
   * de modo que ningún valor en ningún nivel de profundidad sea un array JSON.
   *
   * Flujo:
   *  1. Para cada clave en `data` con valor object/array:
   *       a. Si es array de filas de tabla → convertir a objeto indexado, luego a string
   *       b. Si es objeto anidado (p.ej. data.flujo) → recursión sobre sus valores
   *          para convertir arrays internos, luego a string
   *  2. Inyectar countKey / countCheckedKey para campos expandableTable.
   */

  /**
   * Convierte recursivamente todos los Arrays dentro de un valor en objetos
   * indexados {"0": item0, "1": item1, ...} para que el backend pueda
   * deserializarlos como Dictionary<string,object> sin error.
   * Los arrays en las HOJAS se envuelven en {"#arr": true, "0":..., "1":...}.
   */
  private noArrayForBackend(val: any): any {
    if (val === null || val === undefined) return val;
    if (typeof val !== 'object') return val; // primitivo

    if (Array.isArray(val)) {
      // Convertir array a objeto indexado para que el backend no vea un JSON array
      const obj: any = { '#arr': true };
      for (let i = 0; i < val.length; i++) {
        obj[String(i)] = this.noArrayForBackend(val[i]);
      }
      return obj;
    }

    // Objeto plano: procesar sus valores
    const result: any = {};
    for (const k of Object.keys(val)) {
      result[k] = this.noArrayForBackend(val[k]);
    }
    return result;
  }

  /**
   * Reconstruye un array de filas a partir de un valor que puede ser:
   * - Un array nativo
   * - Una string JSON de array "[{...}]"
   * - Un objeto indexado {"#arr":true, "0":{...}, "1":{...}}
   * - Una string JSON de objeto indexado
   */
  private parseIndexedRows(raw: any): any[] {
    if (Array.isArray(raw)) return raw;

    let obj: any = raw;
    if (typeof raw === 'string' && raw.trim()) {
      try { obj = JSON.parse(raw); } catch (_) {
        try { obj = JSON.parse('[' + raw + ']'); return Array.isArray(obj) ? obj : []; } catch (__) { return []; }
      }
    }

    if (Array.isArray(obj)) return obj;

    if (obj && typeof obj === 'object') {
      if (obj['#arr'] === true) {
        return Object.keys(obj)
          .filter(k => k !== '#arr')
          .sort((a, b) => Number(a) - Number(b))
          .map(k => obj[k]);
      }
      return [obj];
    }

    return [];
  }

  /**
   * Inyecta directamente en `data` los valores de countKey y countCheckedKey
   * para todos los campos expandableTable del esquema.
   * Se llama en ambas ramas del submit ANTES de JSON.stringify(data).
   */
  private injectExpandableTableCounts(data: any): void {
    const components: any[] = this.formLoaded?.components ?? [];
    for (const comp of components) {
      if (comp.type !== 'expandableTable' || !comp.key) continue;

      let rows: any[] = [];
      const rawDirect = data[comp.key];
      if (rawDirect !== undefined) {
        rows = this.parseIndexedRows(rawDirect);
      } else {
        const dotIdx = comp.key.lastIndexOf('.');
        if (dotIdx > 0) {
          const parentKey = comp.key.slice(0, dotIdx);
          const childKey  = comp.key.slice(dotIdx + 1);
          const parentVal = data[parentKey];
          if (parentVal && typeof parentVal === 'object' && parentVal[childKey] !== undefined) {
            rows = this.parseIndexedRows(parentVal[childKey]);
          }
        }
      }

      if (comp.countKey) {
        this.setNestedValue(data, comp.countKey, String(rows.length));
      }
      if (comp.countCheckedKey) {
        const checkCol = (comp.columns ?? []).find((c: any) => c.type === 'checkbox');
        const count = checkCol ? rows.filter((r: any) => !!r[checkCol.key]).length : 0;
        this.setNestedValue(data, comp.countCheckedKey, String(count));
      }
    }
  }

  /**
   * Establece un valor en `data` respetando la notación de punto.
   * Ej: setNestedValue(data, 'flujo.cantidadRegistros', '3')
   *   → data.flujo.cantidadRegistros = '3'  (si data.flujo ya existe como objeto)
   * Si la clave no contiene punto, establece data[key] directamente.
   */
  private setNestedValue(data: any, key: string, value: any): void {
    const dotIdx = key.indexOf('.');
    if (dotIdx < 0) {
      data[key] = value;
      return;
    }
    const parentKey = key.slice(0, dotIdx);
    const childKey  = key.slice(dotIdx + 1);
    if (data[parentKey] && typeof data[parentKey] === 'object' && !Array.isArray(data[parentKey])) {
      // El objeto padre ya existe: establecer el valor dentro de él
      this.setNestedValue(data[parentKey], childKey, value);
    } else {
      // El padre no existe o no es un objeto: guardar como clave plana como fallback
      data[key] = value;
    }
  }

  /**
   * Inicia el envío del formulario en segundo plano:
   *   1. Sube archivos en base64 por chunks si la suma supera el umbral
   *      (activa el modal de progreso automáticamente si aplica).
   *   2. Llama a GuardarDatosTarea con el payload final.
   *   3. Muestra el resultado independientemente del estado del componente.
   *
   * @param data      Datos del formulario (ya mutados con flujo/Documentos)
   * @param modoDocs  true = rama con tabla de documentos
   */
  private iniciarEnvioBackground(data: any, modoDocs: boolean): void {
    if (this.envioEnCurso) {
      return;
    }
    this.envioEnCurso = true;

    const run = async () => {
      // Enlace de formulario expuesto: si la sesión corta venció, se pide un OTP nuevo sin perder lo diligenciado
      if (!(await this.sesionEnlace.asegurarSesion())) {
        this.envioEnCurso = false;
        if (!this.isDestroyed) this.isLoading = true;
        return;
      }

      try {
        await this.uploadBase64FilesIfNeeded(data);

        if (!this.isDestroyed) this.chunkProgress.activo = false;

        const Datos = JSON.stringify(data);

        const response = await lastValueFrom(
          this.http.post<any>(
            AppData.API_URL + `EjecucionTarea/GuardarDatosTarea?IdEjecucionTarea=${this.idEjecucionTarea}`,
            { DatosTarea: Datos },
            { headers: { 'Content-Type': 'application/json' } }
          )
        );

        if (!response.Ok) {
          if (response.CodeError === 'TASK_ALREADY_COMPLETED' || response.CodeError === 'TASK_NOT_AVAILABLE') {
            // Otra petición o pestaña ya la diligenció (o fue cancelada): no se reintenta
            this.baseService.triggerShowModal(
              response.CodeError === 'TASK_ALREADY_COMPLETED' ? 'Tarea ya diligenciada' : 'Tarea no disponible',
              response.Error,
              ModalNotifyTypes.Warning,
              false
            );
            if (!this.isDestroyed && !this.isRedirectAccess) {
              setTimeout(() => { this.abrirDatatableTareas(); }, 3000);
            }
            return;
          }

          const errores: string[] = response.ValidationErrors?.length ? response.ValidationErrors : [response.Error || 'No se pudo guardar la tarea'];
          let mensajeError = '<ul>';
          errores.forEach((err: any) => { mensajeError += `<li>${err}</li>`; });
          mensajeError += '</ul>';
          this.baseService.triggerShowModal(
            modoDocs ? 'Error al editar Proceso' : 'Error al guardar datos tarea',
            mensajeError,
            ModalNotifyTypes.Danger,
            false
          );
          // El backend no tomó la tarea: se vuelve a mostrar el formulario para corregir y reenviar
          this.envioEnCurso = false;
          if (!this.isDestroyed) this.isLoading = true;
        } else {
          if (!this.isDestroyed) {
            this.abrirModalDatosAlmacenados();
          } else {
            this.baseService.triggerShowModal(
              'Tarea guardada',
              'Los datos de la tarea fueron guardados correctamente.',
              ModalNotifyTypes.Success,
              false
            );
          }
        }
      } catch (error: any) {
        this.envioEnCurso = false;
        if (!this.isDestroyed) this.chunkProgress.activo = false;

        // La sesión del enlace venció durante el envío (p. ej. una carga larga de archivos): OTP nuevo y se reintenta
        if (error?.status === 401 && this.sesionEnlace.esSesionEnlace() && !this.isDestroyed) {
          if (await this.sesionEnlace.solicitarOtp()) {
            this.iniciarEnvioBackground(data, modoDocs);
          } else {
            this.isLoading = true;
          }
          return;
        }

        // El enlace se cerró (tarea finalizada, cancelada o vencida)
        if (error?.status === 403 && CODIGOS_ENLACE_CERRADO.includes(error?.error?.CodeError)) {
          this.baseService.triggerShowModal('Formulario no disponible', error.error.Error, ModalNotifyTypes.Warning, false);
          return;
        }

        this.baseService.triggerShowModal(
          'Error al guardar datos tarea',
          error?.error?.Error || error?.message || 'Ha ocurrido un error inesperado',
          ModalNotifyTypes.Danger,
          false
        );
        // Quien llega por un enlace no tiene bandeja de tareas: se deja el formulario para reintentar
        if (!this.isDestroyed && !this.isRedirectAccess) {
          setTimeout(() => { this.abrirDatatableTareas(); }, 5000);
        } else if (!this.isDestroyed) {
          this.isLoading = true;
        }
      }
    };
    run();
  }

  /**
   * Convierte un data URL (data:mime;base64,...) a Blob binario.
   */
  private base64ToBlob(base64DataUrl: string): Blob {
    const parts = base64DataUrl.split(',');
    const mimeMatch = parts[0].match(/:(.*?);/);
    const mimeType = mimeMatch ? mimeMatch[1] : 'application/octet-stream';
    const base64 = parts[1] || parts[0];
    const byteChars = atob(base64);
    const byteArray = new Uint8Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) {
      byteArray[i] = byteChars.charCodeAt(i);
    }
    return new Blob([byteArray], { type: mimeType });
  }

  /** Sanitiza un nombre de archivo para usarlo como IdSesion (solo chars válidos para el backend). */
  private sanitizeForIdSesion(name: string): string {
    return name.replace(/[^a-zA-Z0-9._-]/g, '_');
  }

  /**
   * Lee un valor en `data` respetando la notación de punto.
   * Ej: getNestedDataValue(data, 'flujo.archivo1') → data.flujo.archivo1
   */
  private getNestedDataValue(data: any, key: string): any {
    if (!key) return undefined;
    const parts = key.split('.');
    let current = data;
    for (const part of parts) {
      if (current === null || current === undefined || typeof current !== 'object') return undefined;
      current = current[part];
    }
    return current;
  }

  /**
   * Recorre recursivamente el árbol de componentes del schema para encontrar
   * TODOS los campos de tipo fileInput, incluyendo los anidados dentro de
   * grupos, columnas y otros contenedores.
   */
  private collectAllFileInputFields(components: any[]): any[] {
    const result: any[] = [];
    for (const comp of components) {
      if (comp.type === 'fileInput' && comp.key) {
        result.push(comp);
      }
      // Contenedores que tienen componentes hijos (group, columns, etc.)
      if (Array.isArray(comp.components) && comp.components.length > 0) {
        result.push(...this.collectAllFileInputFields(comp.components));
      }
      // columns tiene columnas que a su vez tienen components
      if (Array.isArray(comp.columns)) {
        for (const col of comp.columns) {
          if (Array.isArray(col.components) && col.components.length > 0) {
            result.push(...this.collectAllFileInputFields(col.components));
          }
        }
      }
    }
    return result;
  }

  /**
   * Revisa TODOS los campos fileInput del schema (incluyendo anidados) que
   * tienen base64 en el data actual. Si la suma de sus tamaños supera
   * CHUNKED_UPLOAD_THRESHOLD_MB, los sube por chunks y reemplaza el base64
   * con { fileId, tempUrl, isChunked: true } antes del submit.
   *
   * Cubre el caso de múltiples archivos cuya SUMA supera el umbral.
   * Los archivos individualmente grandes ya se subieron en File.js al seleccionarlos.
   */
  private async uploadBase64FilesIfNeeded(data: any): Promise<void> {
    if (AppData.ENABLE_CHUNKED_UPLOAD === false) return; // chunked upload deshabilitado por configuración
    const THRESHOLD_BYTES = (AppData.CHUNKED_UPLOAD_THRESHOLD_MB || 20) * 1024 * 1024;
    const CHUNK_SIZE_BYTES = (AppData.CHUNK_SIZE_MB || 5) * 1024 * 1024;

    // Recorrido recursivo del schema para encontrar todos los fileInput
    const allComponents: any[] = this.formLoaded?.components ?? [];
    const fileFields = this.collectAllFileInputFields(allComponents);

    // Recolectar campos con base64 y calcular su peso acumulado
    const camposConBase64: string[] = [];
    let totalBytes = 0;

    for (const comp of fileFields) {
      const val = this.getNestedDataValue(data, comp.key);
      if (val && typeof val === 'object' && val.base64 && !val.isChunked) {
        // base64.length * 0.75 ≈ tamaño original en bytes (sin overhead de encoding)
        totalBytes += Math.floor(val.base64.length * 0.75);
        camposConBase64.push(comp.key);
      }
    }

    if (totalBytes <= THRESHOLD_BYTES) return; // Suma dentro del umbral → sin cambios

    // Activar modal de progreso
    this.chunkProgress = {
      activo: true,
      archivoActual: 0,
      totalArchivos: camposConBase64.length,
      parteActual: 0,
      totalPartes: 0,
      nombreArchivo: ''
    };

    // La suma supera el umbral: subir cada campo con base64 por chunks
    for (let archivoIdx = 0; archivoIdx < camposConBase64.length; archivoIdx++) {
      const key = camposConBase64[archivoIdx];
      const fileValue = this.getNestedDataValue(data, key);
      const blob = this.base64ToBlob(fileValue.base64);
      const fileName = fileValue.name || 'archivo';
      // IdSesion único: {nombreBase}__{timestamp}.{ext} — la extensión SIEMPRE al final
      const _ext = fileName.includes('.') ? fileName.substring(fileName.lastIndexOf('.')) : '';
      const _base = this.sanitizeForIdSesion(fileName.substring(0, fileName.lastIndexOf('.') >= 0 ? fileName.lastIndexOf('.') : fileName.length));
      const idSesion = `${_base}__${Date.now()}${_ext}`;
      const totalPartes = Math.ceil(blob.size / CHUNK_SIZE_BYTES);

      this.chunkProgress.archivoActual = archivoIdx + 1;
      this.chunkProgress.nombreArchivo = fileName;
      this.chunkProgress.parteActual = 0;
      this.chunkProgress.totalPartes = totalPartes;

      let fileId: string | null = null;
      let tempUrl: string | null = null;

      // Subir chunks — el nombre del chunk codifica toda la info que el backend necesita
      for (let i = 0; i < totalPartes; i++) {
        const numeroParte = i + 1; // 1-based
        const start = i * CHUNK_SIZE_BYTES;
        const chunkBlob = blob.slice(start, Math.min(start + CHUNK_SIZE_BYTES, blob.size));
        const chunkFileName = `${idSesion}.part_${numeroParte}_${totalPartes}`;

        const formData = new FormData();
        formData.append('Chunk', chunkBlob, chunkFileName);

        const chunkResp = await lastValueFrom(
          this.http.post<any>(AppData.API_URL + 'EjecucionTarea/SubirChunkArchivo', formData)
        );
        if (!chunkResp.Ok) throw new Error(chunkResp.Error || `Error en parte ${numeroParte} de "${fileName}"`);

        this.chunkProgress.parteActual = chunkResp.Data.PartesRecibidas;

        if (chunkResp.Data.Completado) {
          fileId = chunkResp.Data.FileId;
          tempUrl = chunkResp.Data.TempUrl;
        }
      }

      if (!fileId) throw new Error(`El servidor no confirmó el ensamblado de "${fileName}"`);

      const result = { FileId: fileId, TempUrl: tempUrl };

      // Reemplazar base64 con referencia al archivo ya almacenado (respeta notación de punto)
      this.setNestedValue(data, key, {
        name: fileValue.name,
        fileId: result.FileId,
        tempUrl: result.TempUrl,
        isChunked: true,
        captureContent: fileValue.captureContent,
        variableName: fileValue.variableName,
        captureURL: fileValue.captureURL,
        variableNameURL: fileValue.variableNameURL
      });
    }
  }
}
